import { useFocusEffect } from '@react-navigation/native';
import { FillerBody } from '@/components/FillerBody';
import { useSidebarAnimation } from '@/components/ui/therapist/CollapsibleSidebar/SidebarAnimationContext';

export const FillerTherapist = () => {
  const { setShowHeader } = useSidebarAnimation();

  useFocusEffect(() => {
    setShowHeader(false);
    return () => {
      setShowHeader(true);
    };
  });

  return <FillerBody />;
};
